import React, { useEffect, useState, useRef } from "react";
import {
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Row,
    Label
} from "reactstrap";
import { AvForm, AvField } from 'availity-reactstrap-validation';
import "./Styles.scss"
import CompoundService from "services/Admin/CompoundService"
import UnitTypesService from "services/Admin/UnitTypesService"
import PropertyService from "services/Admin/PropertyService";
import SelectOptions from "components/SelectOptions"
import Select from "react-select";
import PriceInput from "components/PriceInput"
import CurrencyInput from 'react-currency-input-field';
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { appendFilters } from "store/adminFilter/actions";

const initialFormData = {
    unit_type_ids: null,
    min_price: "",
    max_price: "",
    min_size: "",
    max_size: "",
    unit_type: null,
}
const FilterModal = ({ modal, toggle, onSumbit, filterData }) => {
    const [formData, setFormData] = useState(initialFormData)
    const [unitTypeOptions, setUnitTypeOptions] = useState([])
    const formRef = useRef()
    const dispatch = useDispatch()

    useEffect(() => {
        if (!formData.min_price) {
            setFormData((state) => ({ ...state, min_price: "" }))
        }
        if (!formData.max_price) {
            setFormData((state) => ({ ...state, max_price: "" }))
        }
        if (formData.unit_type?.length > 0) {
            let ids = formData.unit_type?.map(type => type.value).join()
            setFormData((state) => ({ ...state, unit_type_ids:  ids}))
        }
    }, [formData.min_price, formData.max_price, formData.unit_type])

    useEffect(() => {
        if (!!filterData ?.unit_type_ids) setFormData((state) => ({ ...state, unit_type_ids: filterData.unit_type_ids }))
        if (filterData ?.unit_type?.length) setFormData((state) => ({ ...state, unit_type: [...filterData.unit_type] }))
        if (filterData ?.min_price ?.length) setFormData((state) => ({ ...state, min_price: filterData.min_price }))
        if (filterData ?.max_price ?.length) setFormData((state) => ({ ...state, max_price: filterData.max_price }))
        if (filterData ?.max_size ?.length) setFormData((state) => ({ ...state, max_size: filterData.max_size }))
        if (filterData ?.min_size ?.length) setFormData((state) => ({ ...state, min_size: filterData.min_size }))
    }, [])

    const handleFieldChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };
    return (
        <AvForm ref={formRef} className='form-horizontal'>
            <Modal isOpen={modal} toggle={toggle}
                className="rightModalSide scrollbar-container mt-0">
                <ModalHeader toggle={toggle}>
                    Unit Filters
                </ModalHeader>
                <ModalBody>
                    <Col md={12}>
                        <SelectOptions
                            label='Unit Type'
                            placeholder='Select'
                            options={unitTypeOptions}
                            handleSelectChange={(data) => {
                                setFormData({ ...formData, unit_type: data });
                            }}
                            selectedOption={formData.unit_type}
                            Service={UnitTypesService}
                            setOptions={(options) => {
                                setUnitTypeOptions(options)
                            }}
                            isMulti={true}
                        />
                    </Col>
                    {/* <Col md={12}>
                        <SelectOptions
                            label='Compound'
                            placeholder='Select'
                            options={compoundOptions}
                            handleSelectChange={(data) => {
                                setFormData({ ...formData, compound_ids: data });
                            }}
                            selectedOption={formData.compound_ids}
                            Service={CompoundService}
                            setOptions={(options) => {
                                setCompoundOptions(options)
                            }}
                            // isMulti={true}
                        />
                    </Col> */}
                    <Row className="my-2 p-0">
                        <Label className="mx-2 px-1">Unit Size</Label>
                    </Row>
                    <Row>
                        <Col md={6}  >
                            <AvField
                                className="mb-3"
                                name={"min_size"}
                                bsSize="lg"
                                value={formData.min_size}
                                onChange={(e => handleFieldChange(e))}
                                placeholder={'From'}
                                type="number"
                                min={"1"}
                            />
                        </Col>
                        <Col md={6}  >
                            <AvField
                                className="mb-3"
                                name={"max_size"}
                                bsSize="lg"
                                value={formData.max_size}
                                onChange={(e => handleFieldChange(e))}
                                placeholder={'To'}
                                type="number"
                                min={"1"}
                            />
                        </Col>
                    </Row>
                    <Row className="my-2 p-0">
                        <Label className="mx-2 px-1">Price</Label>
                    </Row>
                    <Row>
                        <Col md={6} className="price-input" style={{ height: "86px" }}>
                            <CurrencyInput
                                id="min_price"
                                className="px-2 py-3"
                                name="min_price"
                                placeholder="From"
                                value={formData.min_price}
                                allowNegativeValue={false}
                                decimalsLimit={2}
                                onValueChange={(value, name) => {
                                    setFormData({ ...formData, min_price: value })
                                }}
                            />
                        </Col>
                        <Col md={6} className="price-input" style={{ height: "86px" }}  >
                            <CurrencyInput
                                id="max_price"
                                className="px-2 py-3"
                                name="max_price"
                                placeholder="To"
                                value={formData.max_price}
                                allowNegativeValue={false}
                                decimalsLimit={2}
                                onValueChange={(value, name) => {
                                    setFormData({ ...formData, max_price: value })
                                }}
                            />
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter className="mt-4 px-0 d-flex justify-content-between">
                    <button type='button'
                        className='btn btn-light w-120'
                        onClick={() => {
                            setFormData(initialFormData)
                            onSumbit(initialFormData)
                            formRef.current.reset()
                            dispatch(appendFilters({...initialFormData}))
                        }}>
                        Reset Filter
                                </button>
                    <button type='button' onClick={() => {

                        if (parseInt(formData.min_price) === 0 ||
                            parseInt(formData.max_price) === 0) {
                            toast.error("Price must be greater than zero ")
                            return
                        } else if (
                            parseInt(formData.min_size) === 0 ||
                            parseInt(formData.max_size) === 0) {
                            toast.error("Size must be greater than zero ")
                            return
                        } else if (parseInt(formData.min_size) > parseInt(formData.max_size)) {
                            toast.error(" Size Range invalid")
                            return
                        } else if (parseInt(formData.min_price) > parseInt(formData.max_price)) {
                            toast.error("Price Range invalid")
                            return
                        } else {
                            onSumbit(formData)
                            dispatch(appendFilters({...formData}))
                            toggle()
                        }

                    }} className='btn btn-success  w-120'>
                        Apply Filter
                                </button>

                </ModalFooter>
            </Modal>
        </AvForm>

    )
}
export default FilterModal